// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1ULhR","inputWrap":"CustomTip_inputWrap__3co7v"};